// extracted by mini-css-extract-plugin
export default {"tableHeader":"ClientPalletBalanceTable_tableHeader__0M2Rg"};